module.exports = __webpack_public_path__ + "static/img/award5.60eb80f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/award5.jpg
// module id = RzKm
// module chunks = 1